import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/pages/Layout';
import { FeedbackPage } from '@/pages/FeedbackPage';
import { InstallPage } from '@/pages/InstallPage';
import { AccountPage } from '@/pages/AccountPage';
import { BuilderPage } from '@/pages/BuilderPage';

/**
 * App Component - Main application entry point
 * Configures routing with React Router
 *
 * Routes:
 * - / → Redirects to /feedback
 * - /feedback → Feedback browsing page
 * - /install → Installation guide page
 * - /account → Account management page
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/feedback" replace />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="install" element={<InstallPage />} />
          <Route path="builder" element={<BuilderPage />} />
          <Route path="account" element={<AccountPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
